import React from 'react';
import PropTypes from 'prop-types';
import { SmartLink } from '../SmartLink';
import { Image } from '../Image';
import { IconWatchFilled } from '../Icon/IconWatchFilled';
import { IconGallery } from '../Icon/IconGallery';
import { AnimatedImage } from '../Image/AnimatedImage';

const iconConfig = {
  video: IconWatchFilled,
  photo_gallery: IconGallery
};

export const CardImage = ({
  type,
  url,
  nativeLink,
  onClick,
  target,
  title,
  imageEntity,
  imageMaxWidths,
  aspect,
  isAboveTheFold,
  styles,
  animatedImageEntities,
  dataLayerClickEvent
}) => {
  const IconComponent = iconConfig[type];

  return (
    <div css={styles.container}>
      <div css={styles.picture}>
        <SmartLink
          target={target}
          to={url}
          native={nativeLink}
          onClick={onClick}
          title={title}
          dataLayerClickEvent={dataLayerClickEvent}
        >
          {animatedImageEntities.length > 1 ? (
            <AnimatedImage
              entities={animatedImageEntities}
              aspect={aspect}
              maxWidths={imageMaxWidths}
              loading={isAboveTheFold ? 'eager' : 'lazy'}
            />
          ) : (
            <Image
              entity={imageEntity}
              aspect={aspect}
              maxWidths={imageMaxWidths}
              loading={isAboveTheFold ? 'eager' : 'lazy'}
            />
          )}
        </SmartLink>
      </div>

      {IconComponent && (
        <div css={styles.cta}>
          <SmartLink
            target={target}
            to={url}
            native={nativeLink}
            onClick={onClick}
            title={title}
            dataLayerClickEvent={dataLayerClickEvent}
          >
            <IconComponent color="#fc0" size={20} display="block" />
          </SmartLink>
        </div>
      )}
    </div>
  );
};

CardImage.defaultProps = {
  nativeLink: false,
  imageMaxWidths: undefined,
  aspect: undefined,
  isAboveTheFold: false,
  animatedImageEntities: [],
  dataLayerClickEvent: undefined,
  onClick: undefined,
  target: undefined,
  title: undefined
};

CardImage.propTypes = {
  type: PropTypes.oneOf([
    'article',
    'video',
    'show',
    'photo_gallery',
    'hub_page',
    'page'
  ]).isRequired,
  url: PropTypes.string.isRequired,
  nativeLink: PropTypes.bool,
  onClick: PropTypes.func,
  target: PropTypes.string,
  title: PropTypes.string,
  imageEntity: PropTypes.objectOf(PropTypes.any).isRequired,
  imageMaxWidths: PropTypes.objectOf(PropTypes.any),
  aspect: PropTypes.any,
  isAboveTheFold: PropTypes.bool,
  styles: PropTypes.shape({
    container: PropTypes.any,
    picture: PropTypes.any,
    cta: PropTypes.any
  }).isRequired,
  animatedImageEntities: PropTypes.arrayOf(PropTypes.any),
  dataLayerClickEvent: PropTypes.objectOf(PropTypes.any)
};
